export const PORTFOLIO_ROLES = {
	ADMIN: 'admin',
	VIEWER: 'viewer',
	OWNER: 'owner',
};
